import { render, staticRenderFns } from "./AceRegistration.vue?vue&type=template&id=2de90216&"
import script from "./AceRegistration.vue?vue&type=script&lang=ts&"
export * from "./AceRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports